import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { App } from "./App.js";
import { applyInitialTheme } from "./lib/theme.js";
import { installGlobalErrorCapture } from "./lib/debug.js";
import { installPerfConsole } from "./lib/perf.js";

applyInitialTheme();
installGlobalErrorCapture();
installPerfConsole();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
